import gql from 'graphql-tag';
import { short } from '@shared/api/fragments/user';

// Note: separate from ChatMetaToken so that querying userId/mentionType
// (needed to tell "you were mentioned" apart from other people in the same
// message) doesn't widen the payload of every chat message query.
export const mentionToken = gql`
  fragment MentionToken on Token {
    type
    value
    href
    highlight
    userId
    mentionType
  }
`;

export const mentionMessage = gql`
  fragment MentionMessage on ThreadMessage {
    id
    createdAt
    content
    # Note(fant): we need to query senderId,
    # otherwise sender will fail... #schemastitching
    senderId
    sender {
      ...ShortUser
    }
    # Note: core-api's meta, NOT legacyMeta. legacyMeta stitches to the legacy
    # schema, whose Token has no userId/mentionType — they resolve to null there,
    # so we can't tell your own mention from anyone else's.
    meta {
      uuid
      cardId
      tokens {
        ...MentionToken
      }
    }
    channelId
    threadId
  }

  ${mentionToken}
  ${short}
`;

export const mention = gql`
  fragment Mention on Mention {
    id
    channelId
    createdAt
    message {
      ...MentionMessage
    }
  }

  ${mentionMessage}
`;
